import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ExternalLinkIcon, ThinChevronIcon } from '../../../components/Icons';
import { TooltipOnHover } from '../../../components/TooltipOnHover';
import TileMarkdown from './TileMarkdown';
var TILE_DATA_LIST = ['title', 'description', 'status', 'url', 'iconURL', 'fields', 'collapsed', 'pending', 'appName', 'clientId'];

function getTileDataFromNode(node) {
  return TILE_DATA_LIST.reduce(function (memo, key) {
    var value = node.data.get(key);
    return _objectSpread({}, memo, _defineProperty({}, key, value && !!value.toJS ? value.toJS() : value));
  }, {
    title: null,
    description: null,
    fields: null,
    appName: null,
    url: null,
    collapsed: null,
    pending: null,
    status: null,
    iconURL: null
  });
}

var IntegrationTile =
/*#__PURE__*/
function (_Component) {
  _inherits(IntegrationTile, _Component);

  function IntegrationTile() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, IntegrationTile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(IntegrationTile)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onSetCollapsed", function (collapsed) {
      var _this$props = _this.props,
          editor = _this$props.editor,
          node = _this$props.node;
      editor.setNodeByKey(node.key, {
        data: _objectSpread({}, node.data.toJS(), {
          collapsed: collapsed
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCollapseClick", function (event) {
      event.stopPropagation();
      event.preventDefault();

      var _getTileDataFromNode = getTileDataFromNode(_this.props.node),
          collapsed = _getTileDataFromNode.collapsed;

      _this.onSetCollapsed(!collapsed);
    });

    return _this;
  }

  _createClass(IntegrationTile, [{
    key: "render",
    value: function render() {
      var _getTileDataFromNode2 = getTileDataFromNode(this.props.node),
          title = _getTileDataFromNode2.title,
          description = _getTileDataFromNode2.description,
          fields = _getTileDataFromNode2.fields,
          appName = _getTileDataFromNode2.appName,
          url = _getTileDataFromNode2.url,
          collapsed = _getTileDataFromNode2.collapsed,
          status = _getTileDataFromNode2.status,
          iconURL = _getTileDataFromNode2.iconURL,
          pending = _getTileDataFromNode2.pending;

      if (pending) {
        return null;
      }

      return React.createElement("div", Object.assign({}, this.props.attributes, {
        spellCheck: false,
        contentEditable: false,
        className: classNames('transition background-white margin-vertical-medium radius-normal border-medium', {
          'border-primary': this.props.isFocused,
          'border-white shadow': !this.props.isFocused
        })
      }), React.createElement("div", {
        className: classNames('padding-medium flexbox pointer', {
          'padding-bottom-smaller': !collapsed
        }),
        onClick: this.onCollapseClick
      }, status && React.createElement("div", {
        style: {
          background: status.colorHex,
          color: invertColor(status.colorHex, true, {
            darkColor: '#7f7f7f',
            lightColor: '#f6f6f6'
          }),
          whiteSpace: 'nowrap'
        },
        className: "margin-right-small radius-normal padding-horizontal-small shade-20 font-weight-bold"
      }, status.label), collapsed && React.createElement("div", {
        className: "shade-05 ellipsis font-weight-semibold margin-right-normal"
      }, title), url && React.createElement(TooltipOnHover, {
        id: "open-tile-link",
        tooltipContent: appName ? "View in ".concat(appName) : "View",
        placement: "top"
      }, React.createElement("a", {
        className: "transition flexbox flexbox-centered margin-vertical-smaller margin-right-normal shade-30 shade-20-on-hover",
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          marginLeft: 'auto'
        },
        onClick: this.preventEventPropagation // prevent the click event to trigger the collapse behaviour

      }, iconURL ? React.createElement("img", {
        src: iconURL,
        alt: "application-icon",
        style: {
          width: 16,
          height: 16
        }
      }) : React.createElement(ExternalLinkIcon, {
        size: "16"
      }))), React.createElement("div", {
        className: "flexbox flexbox-align-center shade-30 shade-20-on-hover pointer"
      }, React.createElement(ThinChevronIcon, {
        size: "16",
        className: "transition",
        style: {
          transform: collapsed ? 'rotate(90deg)' : 'rotate(-90deg)'
        }
      }))), !collapsed && React.createElement("div", {
        className: "padding-horizontal-medium padding-bottom-medium"
      }, React.createElement("div", {
        className: "shade-05 font-family-larger font-weight-semibold margin-bottom-small"
      }, title), React.createElement("hr", {
        className: "background-shade-50 margin-bottom-normal",
        style: {
          backgroundColor: '#f5f5f7'
        }
      }), description && React.createElement(TileMarkdown, {
        markdown: description
      }), fields && React.createElement("div", {
        className: "line-height-large margin-top-normal",
        style: {
          display: 'grid',
          gridGap: '8px',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, auto))'
        }
      }, fields.map(function (field) {
        return React.createElement("div", {
          key: field.label
        }, React.createElement("div", {
          className: "shade-10 font-weight-semibold"
        }, field.label), React.createElement("div", {
          className: "shade-20"
        }, field.content));
      }))));
    }
  }, {
    key: "preventEventPropagation",
    value: function preventEventPropagation(event) {
      event.stopPropagation();
    }
  }]);

  return IntegrationTile;
}(Component); // (Almost) copied straight from StackOverflow:
// https://stackoverflow.com/a/35970186/1265207


_defineProperty(IntegrationTile, "propTypes", {
  editor: PropTypes.object.isRequired,
  node: PropTypes.object.isRequired,
  attributes: PropTypes.object.isRequired,
  isFocused: PropTypes.bool.isRequired
});

export { IntegrationTile as default };

function intToHex(_int) {
  return _int.toString(16).padStart(2, '0');
}

function invertColor(hex, bw) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$darkColor = _ref.darkColor,
      darkColor = _ref$darkColor === void 0 ? '#000000' : _ref$darkColor,
      _ref$lightColor = _ref.lightColor,
      lightColor = _ref$lightColor === void 0 ? '#FFFFFF' : _ref$lightColor;

  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  } // convert 3-digit hex to 6-digits.


  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  if (hex.length !== 6) {
    throw new Error('Invalid HEX color.');
  }

  var r = parseInt(hex.slice(0, 2), 16),
      g = parseInt(hex.slice(2, 4), 16),
      b = parseInt(hex.slice(4, 6), 16);

  if (bw) {
    // http://stackoverflow.com/a/3943023/112731
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
  } // invert color components


  r = (255 - r).toString(16);
  g = (255 - g).toString(16);
  b = (255 - b).toString(16); // pad each with zeros and return

  return '#' + intToHex(r) + intToHex(g) + intToHex(b);
}